import React from "react";
import { Box } from "@mui/material";

const Cards3A = () => {
  const layout = [
    { num: 1, col: 2, row: 3 },
    { num: 2, col: 4, row: 3 },
    { num: 3, col: 6, row: 3 },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(7, 30px)",
        gridTemplateRows: "repeat(5, 40px)",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 2,
      }}
    >
      {layout.map(({ num, col, row }) => (
        <Box
          key={num}
          sx={{
            gridColumn: col,
            gridRow: row,
            width: 43,
            height: 54,
            backgroundColor: "#1976d2",
            borderRadius: "10px",
            color: "white",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            userSelect: "none",
          }}
        >
          {num}
        </Box>
      ))}
    </Box>
  );
};

export default Cards3A;
